import {connect} from "react-redux";

import Dashboard from "../../../components/Dashboard/DashboardUser/Dashboard";
import * as StudentActions from "../../../store/actions/studentActions";
import * as RemindersActions from "../../../store/actions/remindersActions";
import * as VideoActions from '../../../store/actions/videoActions';
import * as AuthActions from '../../../store/actions/authActions';
import * as AppActions from '../../../store/actions/appActions';

const mapStateToProps = (state) => ({
    ...state.reminders,
    ...state.auth,
    ...state.video,
    ...state.chat
});

const mapDispatchToProps = (dispatch) => ({
    onLoad: (profileId, courseId, token) => {
        dispatch(VideoActions.getUserCourseContent(courseId, token));

        dispatch(VideoActions.getCourseUser(profileId, token));
        dispatch(RemindersActions.getReminders());
    },
    getSingleCourseUser: (profileId, courseId, token) => {
        dispatch(VideoActions.getSingleCourseUser(profileId, courseId, token));
    },
    getCourseNotifications: (courseId, profileId, created, token) => {
        //dispatch(VideoActions.getCourseNotifications(courseId, created, profileId, token));
    },
    hideLoader: () => {
        dispatch(AppActions.appLoading(false));
    },
    getCourseAndSubjects: (courseId, token) => {
        dispatch(VideoActions.getCourseAndSubjects(courseId, token));
    },
    getCompletedSubjects: (cuid, token) => {
        dispatch(VideoActions.getCompletedSubjects(cuid, token));
    },
    createLog: (log, token) => {
        dispatch(VideoActions.createLog(log, token));
    },
    updateLog: (log, token) => {
        dispatch(VideoActions.updateLog(log, token));
    },
    getLocation: () =>{
        dispatch(StudentActions.getLocationStudent())
    },
    getCurrentSubject: (subjectId, token) => {
        dispatch(VideoActions.getUserSubject(subjectId, token));
    },
    updateCourseUser: (cu, pid, token) => {
        dispatch(VideoActions.updateCourseUser(cu, pid, token));
    },
    updateProfile: (profile, token) => {
        dispatch(AuthActions.updateProfile(profile, token));
    },
    getFlags: (cu, token) => {
        dispatch(VideoActions.getFlags(cu, token))
    }
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Dashboard);


// WEBPACK FOOTER //
// ./src/containers/Dashboard/DashboardUser/DashboardContainer.js